import { useEffect, useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { useDispatch, useSelector } from 'react-redux';
import {
  CartState,
  customerSlice,
  StoreState,
  useClearCartEffect,
} from '../../../services';
import { PaymentRequestOptions, StripeError } from '@stripe/stripe-js';
import { Route } from '../../../enums';

export const useStripeCheckoutAppleGooglePaymentEffect = (
  paymentRequestOption: PaymentRequestOptions
) => {
  const stripe = useStripe();
  const dispatch = useDispatch();
  const { converted } = useSelector(
    (state: StoreState) => state.customers.customer
  );
  const cartState = useSelector(
    (state: StoreState) => state.orders.cart
  ) as CartState;

  const { clearCart } = useClearCartEffect(Route.PATIENT_WELCOME_CONGRATS);
  const cart = useSelector((state: StoreState) => state.orders.cart.cart);
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [clientSecret, setClientSecret] = useState('');
  const [success, setSucceeded] = useState(false);
  const [error, setError] = useState(undefined as unknown as StripeError);

  useEffect(() => {
    if (converted) {
      clearCart();
    }

    if (success) {
      dispatch(customerSlice.actions.checkout(cartState));
    }

    if (stripe) {
      const pr = stripe.paymentRequest(paymentRequestOption);
      setClientSecret(cart?.fetched?.paymentIntentClientSecret as string);

      pr.canMakePayment().then((result) => {
        if (result) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          setPaymentRequest(pr);
        }

        if (pr) {
          const clientStripeSecret = clientSecret
            ? clientSecret
            : (cart?.fetched?.paymentIntentClientSecret as string);
          pr.on('paymentmethod', async (ev: any) => {
            console.log('payment Method event types:');
            console.log(ev);
            const { paymentIntent, error: confirmError } =
              await stripe.confirmCardPayment(
                clientStripeSecret,
                { payment_method: ev.paymentMethod.id },
                { handleActions: false }
              );
            console.log(confirmError);
            if (confirmError) {
              ev.complete('fail');
            } else {
              console.log('Intent Status: ' + paymentIntent?.status);
              setSucceeded(true);
              if (paymentIntent?.status === 'requires_action') {
                const { error } = await stripe.confirmCardPayment(clientSecret);
                setError(error as StripeError);
              }
            }
          });
        }
      });
    }
  }, [stripe, dispatch, clearCart, converted, cartState]);

  return {
    success,
    paymentRequest,
    error,
  };
};
